import React from 'react'
import PropTypes from 'prop-types'
import { Element } from 'react-scroll'

import Icon from 'Pods/Shared/Icon/Icon'

import Section from './Section'

function InfoSection({
  id,
  title,
  text,
  linkText = '',
  link = '',
  image,
  altText,
  sectionClassName = '',
}) {
  return (
    <Element id={id} className="element">
      <Section
        sectionClassName={`info-section info-section--white ${sectionClassName}`}
        rowClassName="align-items-center"
      >
        <div className="col-12 col-md-5">
          <img src={image} alt={altText} className="info-section__image--full-width" />
        </div>
        <div className="col-12 col-md-6 offset-md-1">
          <h2 className="heading-40 info-section__heading">{title}</h2>
          <p className="heading-20 info-section__description">{text}</p>
          {link && linkText && (
            <a href={link}>
              {linkText}
              <Icon type={['fas', 'chevron-right']} className="u-ml10" />
            </a>
          )}
        </div>
      </Section>
    </Element>
  )
}

InfoSection.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  linkText: PropTypes.string,
  link: PropTypes.string,
  image: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
  sectionClassName: PropTypes.string,
}

export default InfoSection
